/*
 * Created by yvesb on 04/04/2017.
 */
import { ceIn, ce } from 'src/kernel/dom'
import { isIphoneOrIpad } from '../kernel/kernel'
/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * https://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

/**
 * Crée un input (de type text par défaut) et le retourne (sans l'insérer dans le dom, utiliser addInput pour ça)
 * L'input créé respecte le sens d'édition du conteneur, donc si la langue est l'arabe il est par défaut en right to left
 * Pour imposer un input en left to right, utiliser getMtgInput
 * @param {Object} [attrs] les attributs qui seront mis sur l'input créé
 * @returns {HTMLInputElement}
 * @constructor
 */
export function getMtgInputBase (attrs = {}) {
  if (!attrs.type) attrs.type = 'text'
  const input = ce('input', attrs)
  input.setAttribute('spellcheck', 'false')
  if (isIphoneOrIpad) {
    Object.assign(input.style, {
      webkitAppearance: 'none',
      border: '1px solid #333',
      backgroundColor: '#fff',
      borderRadius: '3px',
      boxShadow: '0 0 4px rgba(0,0,0,0.3)'
    })
  } else input.style.border = '1px solid #333'
  // Ligne ci-dessous pour ne pas avoir de suggestions d'entrée automatique dans les input
  input.setAttribute('autocomplete', 'off')
  input.isRed = false
  input.onblur = function () {
    if (input.isRed) {
      input.style.backgroundColor = '#FFFFFF'
    }
  }
  input.marquePourErreur = function () {
    input.style.backgroundColor = '#F5a9BC'
    input.isRed = true
  }
  input.demarquePourErreur = function () {
    if (input.isRed) {
      input.style.backgroundColor = '#FFFFFF'
    }
    input.isRed = false
  }
  input.onkeyup = function () {
    if (input.isRed) {
      input.style.backgroundColor = '#FFFFFF'
    }
    input.isRed = false
  }
  return input
}

/**
 * Crée un input (de type text par défaut) et le retourne (sans l'insérer dans le dom, utiliser addInput pour ça)
 * L'input créé impose le sens left to right (pour éditer les noms des calculs par exemple)
 * @param {Object} [attrs] les attributs qui seront mis sur l'input créé
 * @returns {HTMLInputElement}
 * @constructor
 */

export function getMtgInput (attrs = {}) {
  const input = getMtgInputBase(attrs)
  input.setAttribute('dir', 'ltr')
  return input
}

/**
 *
 * @param {Object} options
 * @param {HTMLElement} options.container
 * @param {string} [options.label] Si présent ça ajoutera un tag <label> autour de l'input
 * @param {Object<string, string>} [options.attrs] Des attributs à ajouter à l'input
 * @return {HTMLInputElement}
 */
export function addInput ({ container, label, attrs } = {}) {
  if (label) {
    container = ceIn(container, 'label', label)
    // et on ajoute un peu de marges pour éviter de trop coller le label à l'input
    if (typeof attrs.style !== 'string') attrs.style = ''
    attrs.style = 'margin:0.2em 1em;'
  }
  return ceIn(container, 'input', attrs)
}
